// extracted by mini-css-extract-plugin
export var chip = "_ej-0";
export var filterDropdown = "_ej-5";
export var filterItem = "_ej-6";
export var icon = "_ej-1";
export var removeButton = "_ej-3";
export var removeIcon = "_ej-4";
export var separator = "_ej-2";